import { Adresse } from './contact/adresse';

export class UserContact {
  public id: number;
  public active: boolean;
  public userId: number;
  public login: string;
  public contactForUser: {
    contactId: number;
    nom?: string;
    prenom?: string;
    adresse?: Adresse;
  };
  public contactId?: number;
  public isSSOOkIcon;
  public iconTooltip;
  public name?: string;

  constructor(data?) {
    Object.assign(this, data);
    this.name = (this.contactForUser.nom ? this.contactForUser.nom + ' ' : '') + (this.contactForUser.prenom ? this.contactForUser.prenom : '');
    if (this.name) {
      this.name = this.name.trimStart();
    }
    this.id = this.userId;
    this.contactId = this.contactForUser.contactId ? this.contactForUser.contactId : null;
  }
}

export class UserContactForRecipientModal {
  name: string;
  label: string;
  nom: string;
  prenom: string;
  typeContactID: number;
  id: number;
  value: number;
  userId: number;
  isUser: boolean;
  active: boolean;
}
